import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { Base64UrlService } from '@app/services/base64url.service';
import { BspService, BspSubscriptionEdit } from '@app/services/bsp.service';

@Component({
  selector: 'tt-bsp-sub',
  templateUrl: './bsp-sub.component.html',
  styleUrls: ['./bsp-sub.component.css'],
  standalone: false,
})
export class BspSubComponent implements OnInit {
    public params?: { bspsub_keyno: string };

    public page?: BspSubscriptionEdit;

    public saving = false;

    constructor(
        private bsp: BspService,
        private base64: Base64UrlService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public async save(): Promise<void> {
        if (!this.page) return;

        this.saving = true;

        try {
            const edit = {
                ...this.page,
                html_description_base64: this.base64.urlEncode(this.page.html_description_base64)
            };

            const response = await this.bsp.saveSubscription(edit);

            if (response.errorcode !== '0') {
                await this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });

                return;
            }

            await this.navigator?.back();
        } finally {
            this.saving = false;
        }
    }

    public async ngOnInit(): Promise<void> {
        const params = (this.navigator?.params ?? this.params) as { bspsub_keyno?: string } | undefined;

        if (params?.bspsub_keyno !== undefined) {
            this.page = await this.bsp.getSubscription(params.bspsub_keyno);
            this.page.html_description_base64 = this.base64.urlDecode(this.page.html_description_base64);
        }
    }
}
